import { useState, useCallback } from 'react'

export const useReload = (): [number, () => void] => {
  const [reload, setReload] = useState<number>(0)
  const forceReload = useCallback(() => {
    setReload((reload) => reload + 1)
  }, [])
  return [reload, forceReload]
}
